<template>
    <div class="hpComp reveal"> <!-- hLine -->
        <!-- background video -->        
        
         <div class="hpCompVideoBg">
            <video 
                loop="loop" 
                muted="muted" 
                id="compVideo1" 
                playsinline 
                :src="'/img/video_bg.mp4'"></video>    
        </div>
 
        <div class="comp-wrapper">
            <div class="comp-container">
                <div class="split-text title section-title">
                    <p>{{secData.title}}</p>
                </div>  
                <div class="comp-contents">
                    <div class="comp-item" v-for="(item,index) in secData.content" :key="'comptext_'+index">
                        <div class="elememt fs16" :style="'--index:'+index" v-html="item"></div>    
                    </div>
                </div>
                <div class="comp-links">
                    <a v-for="(item,index) in secData.links" 
                        :href="item.url" 
                        :key="'link_'+index" 
                        :style="'--index:'+index"
                        class="comp-link" 
                        target="_blank">
                        <!-- <sh :style="'--index:'+index"></sh> -->
                        <span :style="'--index:'+index">{{item.title}}</span>
                        <i class="colWhite fal fa-chevron-right pl-s" aria-hidden="true"></i>
                        <!-- <bg></bg> -->


                    </a>
                </div>
            </div>

            <div class="compComit-container">
                <div class="compComit">            
                    <div class="split-text fs20">Scientific Committee of the Competition</div>
                </div>        
                <div class="xrCom xrCommittee">
                    <div 
                    v-for="(comItem,cIndex) in secData.committee" 
                    @click="showCom(cIndex)" 
                    class="xrComItem compSpeakerFxUp" 
                    :style="'--delay:0.5s;--index:'+cIndex"              
                    :key="'com_'+cIndex">
                        <div class="xrImg" :style="getSpeakerImg(comItem)"></div>
                        <div class="xrOver">
                        <div class="xrTitle">{{comItem.name}} <span class="plus"><i class="fal fa-chevron-right" ></i></span></div>                
                        </div>

                    </div>
                </div> 
            </div>            


        </div>


    </div>
</template>

<style>
    .colWhite
    {
        color: #fff !important;
    }
  .hpComp.reveal .compSpeakerFxUp
  {
    opacity: 0;
    transform: translateY(50px);
    transition: all ease-in-out 1s;
    transition-delay: calc(var(--delay) + (0.1s * var(--index))) !important;
  }
  .hpComp.reveal.active .compSpeakerFxUp
  {
    opacity: 1;transform: translateY(0px);
  }

    .compComit
    {
        padding-top: 30px;
    }
    .compComit div
    {
        clear: both;
        color: #2aa4d8;
        padding-top: 4px;
    }
    .hpCompVideoBg
    {
        position: absolute;
        width: 100%;
        height: 100%;        
        top: 0px;
        left: 0px;
        pointer-events: none;
    }
    .hpCompVideoBg video
    {
        opacity: .2;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }    



    .hpComp
    {        
        width: 100vw;
        min-height: 100vh;
    }
    .comp-wrapper
    {
        min-height: 100vh;
        height: 100%;
        width: 100%;
    }

    .comp-container{
        margin: auto;
        width: clamp(600px,60vw,1500px);
        text-align: center;
    }
    .compComit-container
    {
        clear: both;
        display: block;
        margin: auto;
        width: clamp(600px,80vw,1500px);
        text-align: center;
    }


    .hpComp 
    {
        color:#393939;        
    }
    .hpComp .title
    {
        color:#2aa4d8;
    }
    .comp-contents
    {
        padding-top: 30px;
        text-align: left;
        width: 40vw;
        margin: auto;
    }
    .comp-contents .elememt 
    {
        font-weight: 300 !important;
        text-align: left;
        padding-bottom: 18px;
        color: #fff;
        opacity: 0;
    }
    .comp-contents .elememt b
    {
        font-weight: 500 !important;
    }
    .comp-links
    {
        padding-top: 30px;
    }
    .comp-links a
    {
        margin: 10px;
    }

    @media all and (max-device-width: 1024px){  
    }



    /* ///////// ANIMATE TEXT AND GRADIENT BUTTONS ///////// */
    /* ///////// ANIMATE TEXT AND GRADIENT BUTTONS ///////// */
    /* ///////// ANIMATE TEXT AND GRADIENT BUTTONS ///////// */
    /* ///////// ANIMATE TEXT AND GRADIENT BUTTONS ///////// */
    .hpComp.reveal .comp-contents .elememt     
    {
        opacity: 0;
        transition: all ease-in-out 1s;
        transition-delay: calc(0.4s + (var(--index) * 0.2s));
    }
    .hpComp.reveal.active .comp-contents .elememt     
    {
        opacity: 1;
    }

    .hpComp.reveal .rbox span
    {
        color:#fff;
        opacity: 0;
        transition: all ease-in-out 1.2s;
        transition-delay: calc(1.3s + (var(--index) * 0.4s));
    }     
    .hpComp.reveal.active .rbox span
    {
        opacity: 1;
    }     
    
    .hpComp.reveal .rbox sh
    {   
        clip-path: inset(0 100% 0 0);        
        transition: all ease-in-out 1.5s;
        transition-delay: calc(0.8s + (var(--index) * 0.4s));
    }

    .hpComp.reveal.active .rbox sh
    {
        opacity: 1;clip-path: inset(0 0 0 0);    
    }
    /* ///////// ANIMATE TEXT AND GRADIENT BUTTONS ///////// */
    /* ///////// ANIMATE TEXT AND GRADIENT BUTTONS ///////// */
    /* ///////// ANIMATE TEXT AND GRADIENT BUTTONS ///////// */


    .comp-link {
        border-radius: 50px;
        padding:18px 25px;
        display: inline-block;
        font-size: 13px;
        cursor: pointer;
        border:solid 2px #c49498;
    }
    .comp-link span{
        color:#fff;
    }
    .comp-link:hover {
        border:solid 2px #2aa4d8;
    }



    .rbox {
        position: relative;
        transform-style: preserve-3d;
        border-radius: 50px;
        height: auto;
        padding:18px 25px;
        display: inline-block;
        font-size: 13px;
        cursor: pointer;
        color:#fff;
    }
    .rbox span{color:#fff;}
    .rbox bg
    {   
        opacity: 0;
        border-radius: 50px;
        position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(45deg, #c49498, #2aa4d8);
        top: 0px;
        left: 0px;
        z-index: -10;
        transition: all ease 0.4s;
    }
    .rbox:hover bg
    {
        opacity: 1;
    }

    @supports (mask-composite:exclude) {
        .rbox sh {
            position: absolute;
            inset: calc(0px - 5px - 0px);
            border: calc(0px + 5px + 0px) solid #0000;
            border-radius: calc(0px + 5px + 0px + 50px);
            -webkit-mask: linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);
            -webkit-mask-composite: xor;
                    mask-composite: exclude;
            transform: translateZ(-1px);
            pointer-events: none;
        }
        .rbox sh::before {
            content: "";
            position: absolute;
            inset: -2px;
            border-radius: 50px;
            background: linear-gradient(45deg, #c49498, #2aa4d8);
            transform: translate(0px,0px);
        }
        .rbox:hover sh::before {            
        }
    }    
    @supports not (mask-composite:exclude) {
        .rbox {
            background-color: transparent;
            border:solid 2px #c49498;
        }
    }    





    @media (max-width: 850px) { 
        .comp-container{
            width: 80vw;
        }
        .compComit-container
        {
            width: 80vw;
        }
        .compComit{
            padding-top: 30px;
        }
        .comp-contents {
            width: 80vw !important;
        }    
        .comp-links
        {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
        .comp-contents {
            width: 70vw !important;
        }    

    }

    /* ipad pro ... */    
  @media only screen and (min-width: 1024px) and (max-height: 1366px)
      and (-webkit-min-device-pixel-ratio: 1.5) and (hover: none) {
        .hpComp {
            min-height: 1px;
        }        
        .comp-wrapper {
            min-height: 1px;
        }        
  }




  /* LARGE SCREENS */
  @media (min-width: 1600px) { 
  }

</style>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines }         from "@/utils";
import site_data from "@/site_data.json"

export default {
  components:{},
  data()
  {
    return {
      secData:site_data[1].COMPETITION
      //secData.committee
    }
  },
  mounted()
  {

  },
  methods:
  {
    showCom(index)
    {
        //alert("emitting:"+index);

      this.$emit("show-compcom",index);
    },
    getSpeakerImg(item)
    {
      if(item.img.indexOf('http')>-1)
      {
        return "background-image: url('"+item.img+"')";
      }
      return "background-image: url('img/speakers/"+item.img+"')";
    },
    getItemData(item)
    {

    }
  }
};
</script>
